export const LAMPADA_STATUS_REFRESH_INTERVAL_MS = 30 * 1000;

export function parseLampadaDateToTimestamp(dateString) {
	if (!dateString) { return NaN; }

	const parts = dateString.trim().split(/[ T]/);
	if (parts.length !== 2) { return NaN; }

	const dateParts = parts[0].split("-");
	const timeParts = parts[1].split(":");
	if (dateParts.length !== 3 || timeParts.length < 2) { return NaN; }

	const year = parseInt(dateParts[0], 10);
	const month = parseInt(dateParts[1], 10);
	const day = parseInt(dateParts[2], 10);
	const hour = parseInt(timeParts[0], 10);
	const minute = parseInt(timeParts[1], 10);
	const second = timeParts.length > 2 ? parseInt(timeParts[2], 10) : 0;

	if ([year, month, day, hour, minute, second].some(Number.isNaN)) { return NaN; }

	return new Date(year, month - 1, day, hour, minute, second).getTime();
}

export function hasLampadaPersoConnessione(lampadaData, currentTimestamp = Date.now()) {
	if (!lampadaData || !lampadaData.dataUltimoControllo || lampadaData.secondiProssimaConnessione == null) {
		return false;
	}

	const timestampUltimoControllo = parseLampadaDateToTimestamp(lampadaData.dataUltimoControllo);
	const secondiProssimaConnessione = Number(lampadaData.secondiProssimaConnessione);

	if (!Number.isFinite(timestampUltimoControllo) || !Number.isFinite(secondiProssimaConnessione) || secondiProssimaConnessione < 0) {
		return false;
	}

	const prossimaConnessioneAttesa = timestampUltimoControllo + secondiProssimaConnessione * 1000;
	const sogliaDisconnessione = prossimaConnessioneAttesa + LAMPADA_STATUS_REFRESH_INTERVAL_MS;
	return currentTimestamp > sogliaDisconnessione;
}
